import axios from 'axios';

export default {
  install(Vue, options) {
    Vue.prototype.$http = Vue.http = axios;
    //界面刷新时保持可用
    if (process.env.NODE_ENV !== 'production' && localStorage.serverAddress !== null) {
      axios.defaults.baseURL = localStorage.serverAddress;
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/http.js